export interface SearchState {
    data: Record<string, any>;
    showResults: boolean;
    promptHistory: string[];
}

export enum SearchActionTypes {    
    SET_DATA = 'SET_DATA',
    TOGGLE_RESULTS = 'TOGGLE_RESULTS',
    ADD_PROMPT_HISTORY = 'ADD_PROMPT_HISTORY',
    INIT_HISTORY = 'INIT_HISTORY',
    RESET = 'RESET'
}

interface SetDataAction {
    type: SearchActionTypes.SET_DATA;
    payload: Record<string, any>;
}

interface ToggleResultsAction {
    type: SearchActionTypes.TOGGLE_RESULTS;
    payload: boolean;
}

interface AddPromptHistoryAction {
    type: SearchActionTypes.ADD_PROMPT_HISTORY;
    payload: string[];
}

interface ResetState {
    type: SearchActionTypes.RESET
}

export type SearchAction =
    | SetDataAction
    | ToggleResultsAction
    | AddPromptHistoryAction
    | ResetState;
